import { Map } from 'immutable';
import { combineActions, handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';

import { deleteCreditProfileSuccess } from '../credit-profile/actions';

import * as actions from './actions';
import { type CreditReportStore, mkCreditReportStore } from './types';

const creditReportReducer = handleActions<
  CreditReportStore,
  | ReturnType<typeof deleteCreditProfileSuccess>
  | ReturnType<typeof actions.getCreditReportSuccess>
  | ReturnType<typeof actions.refreshCreditReportSuccess>
  | ReturnType<typeof actions.getRefreshedCreditReportSuccess>
>(
  {
    [combineActions(actions.getCreditReport, actions.refreshCreditReport).toString()]: (state: any) =>
      state.merge({ isLoading: true }),

    [actions.getCreditReportSuccess.type]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),

    [actions.refreshCreditReportSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResource(state.merge({ loadPending: false }), payload),

    // QCS deletes the old credit report and sends a new credit report with a new ID.
    // resetting the resourcesById before merging the new credit report.
    [actions.getRefreshedCreditReportSuccess.type]: (state, { payload }) =>
      resourceUpserters.upsertResource(state.merge({ loadPending: false, resourcesById: Map() }), payload),

    [deleteCreditProfileSuccess.type]: () => mkCreditReportStore(),

    [combineActions(
      actions.getCreditReportFailure,
      actions.refreshCreditReportFailure,
      actions.getRefreshedCreditReportFailure,
    ).toString()]: (state: any, { payload }: any) => resourceUpserters.completeWithError(state, payload),
  },
  mkCreditReportStore(),
);

export default creditReportReducer;
